import { formatNumber } from '../../utils/numberFormat';

export const formatJackpotNumber = (num: number, after: number): string => {
  return formatNumber(num, { minimumFractionDigits: after, maximumFractionDigits: after }, 'en-US');
};
